<!-- TODO(ppt): [class.has-description]="config.description && !isCondensed" -->
<div class="condensed-body-wrapper" [ngClass]="!reportOptions.hideImages ? 'has-image' : 'hide-image'">
  <!-- REMOVE COL -->
  <div class="image-header">
    <!-- POSITION COL -->
    <div class="position">
      {{
        reportRecordData.data[0] && reportRecordData.data[0].position
          ? reportRecordData.data[0].position
          : reportRecordData.position
      }}.
    </div>
    <div class="record-actions print-hidden">
      <mat-icon class="green-close" color="y-icon" svgIcon="close-icon-grey" (click)="removeRecord.emit()"></mat-icon>
      <ng-container
        [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-goes-to-record'"
        [ngTemplateOutletContext]="{
          classes: '',
          urlParams: reportRecordData | reportRecordRouteFn: { templateId: currentView.templateId, entity: entity },
          content: goToIcon,
          navigateOptions: {
            type: 'static',
            ids: allRecords | extractRecordsFromReportRecordFn | pickDataFrom: 'data.entity.id',
            entity: entity,
          },
        }"
      ></ng-container>
      <ng-template #goToIcon>
        <mat-icon class="print-hidden open-in-new-tab-icon" color="y-icon" svgIcon="new-window"></mat-icon>
      </ng-template>
    </div>
  </div>

  <!--   IMAGE COL -->
  <div class="image" *ngIf="imageField && !reportOptions.hideImages">
    <div
      miq-bg-image
      class="image-border"
      customPublishIconClass="custom-publish-icon-condensed"
      [ngClass]="{ 'no-border': reportOptions.hideImages }"
      [showImage]="!reportOptions.hideImages"
      [secureImage]="
        reportRecordData
          | reportFieldFormatter
            : { templateId: currentView.templateId, field: imageField, joinString: true, onlyUrl: false, isPDF: isPDF }
          | async
      "
    ></div>
  </div>
  <div
    class="subset-title"
    *ngIf="templateProjectionMap && (templateProjectionMap | selectTemplateOutlet: 'miq-confidentiality-control-tmpl')"
  >
    <ng-container
      [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-confidentiality-control-tmpl'"
      [ngTemplateOutletContext]="{ record: reportRecordData.data[0], reportItem: reportRecordData, displayLabel: true }"
    ></ng-container>
  </div>
  <div class="complete-row">
    <div class="data">
      <!-- ALL OTHER PROPS -->
      <div class="subsets" *ngFor="let subset of bodyGroups">
        <ul *ngIf="subset && subset?.fields.length">
          <li *ngFor="let field of subset.fields" (click)="emitEditableFields($event, field.id)">
            <ng-container *ngTemplateOutlet="fieldRendering; context: { field: field }">></ng-container>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- ITEM DESCRIPTION -->
  <div class="property-header-desc" *ngIf="footerGroups && footerGroups.length">
    <div class="property-header-desc-row" *ngFor="let subset of footerGroups">
      <ul>
        <li *ngIf="subset.header != null">
          <label>{{ subset.header }}</label>
        </li>
        <li *ngFor="let field of subset.fields" (click)="emitEditableFields($event, field.id)">
          <ng-container *ngTemplateOutlet="fieldRendering; context: { field: field }">></ng-container>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #fieldRendering let-field="field">
  <!--
    TODO(ppt): for future contacts link requirements, routeFn and miq-goes-to-record
     component projection will be required on this template
  -->
  <ng-container *ngIf="!!field.label; else noLabel">
    <ng-container *ngIf="field | displayField: reportRecordData.data[0]">
      <label
        [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
        *ngIf="
          reportRecordData
            | isFieldVisible: { templateId: currentView.templateId, field: field, reportOptions: reportOptions }
        "
        >{{ field.label }}</label
      >
      <span
        class="{{ field.class }}"
        [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
        *ngIf="
          reportRecordData
            | isFieldVisible: { templateId: currentView.templateId, field: field, reportOptions: reportOptions }
        "
      >
        {{
          reportRecordData
            | reportFieldFormatter
              : {
                  templateId: currentView.templateId,
                  field: field,
                  joinString: true,
                  onlyUrl: false,
                }
            | async
        }}
      </span>
    </ng-container>
  </ng-container>

  <ng-template #noLabel>
    <span
      class="{{ field.class }}"
      [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
      >{{
        reportRecordData
          | reportFieldFormatter
            : {
                templateId: currentView.templateId,
                field: field,
                joinString: true,
                onlyUrl: false,
              }
          | async
      }}</span
    >
  </ng-template>
</ng-template>
